export abstract class StringExtend {
	public static readonly isNullOrEmpty = (val: string) => {
		return val === undefined || val === null || (typeof val === "string" && val.trim() === "") || (typeof val === "string" && val.replace(" ", "").trim() === "");
	}
}